import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { reverseArrowIconDirectionForRtl } from '@application/Interfaces/Icons/utils'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

import { SVG } from './ArrowDirectionIcon.styled'

export const ArrowDirectionIcon: IconComponent = ({
    className,
    colorCode = 'white',
    width = 16,
    height = 12,
    direction = 'right',
}) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    const directionTransformed = reverseArrowIconDirectionForRtl({
        iconDirection: direction,
        themeDirection: theme.direction,
    })

    return (
        <SVG
            className={className}
            width={width}
            height={height}
            direction={directionTransformed}
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.4146 0.89138L10.4146 0.891431L10.4206 0.897488L15.4772 5.95459L15.4772 5.95464L15.4838 5.96103C15.5052 5.98163 15.5058 6.01805 15.4834 6.0397L15.4833 6.03964L15.4773 6.04572L10.4207 11.1023L10.4206 11.1022L10.4142 11.1089C10.3969 11.1268 10.3554 11.1363 10.3214 11.1023L10.321 11.1019C10.3126 11.0935 10.3044 11.0787 10.3044 11.0557C10.3044 11.0336 10.3123 11.0136 10.3258 10.9987L14.4098 6.92235L15.2652 6.06847H14.0565H0.564497C0.535397 6.06847 0.5 6.04357 0.5 5.99584C0.5 5.97414 0.507718 5.95929 0.51797 5.94903C0.528221 5.93877 0.543218 5.93092 0.565121 5.93084C0.565182 5.93084 0.565243 5.93084 0.565305 5.93084L14.0565 5.93084H15.2636L14.4101 5.07728L10.3214 0.98862L10.321 0.988209C10.3122 0.979391 10.3044 0.964483 10.3044 0.943254C10.3044 0.922018 10.3122 0.906734 10.3214 0.897506C10.3552 0.863748 10.3965 0.872639 10.4146 0.89138Z"
                fill={color}
                stroke={color}
            />
        </SVG>
    )
}
